
import { defineComponent, ref, onMounted, onBeforeUnmount } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useApiWithAuth } from "../../modules/api";
import { TURNSTILE_VERIFIED, TURNSTILE_ENABLED } from "../../modules/auth";
import { useToast } from "../../modules/message";

export default defineComponent({
  setup() {
    const router = useRouter();
    const route = useRoute();
    const turnstileRef = ref<HTMLElement>();
    const verificando = ref(false);
    let widgetId: string | undefined;

    const verificar = (token: string) => {
      if (verificando.value) return;
      verificando.value = true;
      const { post } = useApiWithAuth();
      post("/verificacao", { turnstileToken: token })
        .then(() => {
          sessionStorage.setItem(TURNSTILE_VERIFIED, "true");
          const redirect = route.query.redirect as string;
          router.push(redirect || { name: "home" });
        })
        .catch((e) => {
          verificando.value = false;
          if (!e?.response) {
            useToast().error(
              "Não foi possível conectar ao servidor. Verifique sua internet " +
                "ou se a rede/firewall da sua empresa permite acesso a " +
                "aet-api.govpass.com.br, e tente novamente.",
              { life: 20000 }
            );
          } else {
            useToast().error(
              e.response.data?.message ||
                "Não foi possível concluir a verificação. Tente novamente."
            );
          }
        });
    };

    const renderTurnstile = () => {
      if (window.turnstile && turnstileRef.value) {
        widgetId = window.turnstile.render(turnstileRef.value, {
          sitekey: "0x4AAAAAAC21H5ax1d8XlZhC",
          callback: (token: string) => {
            verificar(token);
          }
        });
      }
    };

    onMounted(() => {
      // em desenvolvimento o desafio nao roda; quem chegar aqui por link direto segue adiante
      if (!TURNSTILE_ENABLED) {
        sessionStorage.setItem(TURNSTILE_VERIFIED, "true");
        router.push((route.query.redirect as string) || { name: "home" });
        return;
      }
      const interval = setInterval(() => {
        if (window.turnstile?.render) {
          clearInterval(interval);
          renderTurnstile();
        }
      }, 200);
      setTimeout(() => clearInterval(interval), 10000);
    });

    onBeforeUnmount(() => {
      if (widgetId && window.turnstile) {
        window.turnstile.remove(widgetId);
      }
    });

    return {
      turnstileRef
    };
  },
  components: {}
});
